<div class="delivery-management">
  <div class="delivery-card">
    <p class="delivery-card-desc">
      <strong>One-time price adjustment applied directly to the current delivery prices.
      Changes are saved automatically — you'll still need to
      Schedule a Sync to push them to the POS.</strong>
    </p>

    <div class="applying-to">
      Applying to: <strong>{{ productType.name }}</strong>
      <ng-container *ngIf="!isCombo && selectedCategory.id !== '-1'">
        / <strong>{{ selectedCategory.name }}</strong>
      </ng-container>
      <ng-container *ngIf="isCombo && selectedEntree.id !== '-1'">
        / <strong>{{ selectedEntree.name }}</strong>
      </ng-container>
      &nbsp;·&nbsp;
      <span class="item-count">
        {{ affectedCount != null ? affectedCount : '...' }} items will be affected
      </span>
    </div>

    <div class="form-row" *ngIf="!isCombo">
      <kendo-label text="Category"></kendo-label>
      <kendo-dropdownlist
        [data]="categories"
        [(ngModel)]="selectedCategory"
        textField="name"
        valueField="id"
        [defaultItem]="defaultCategory"
        (ngModelChange)="fetchCount()"
      ></kendo-dropdownlist>
    </div>

    <div class="form-row" *ngIf="isCombo">
      <kendo-label text="Entree"></kendo-label>
      <kendo-dropdownlist
        [data]="comboEntrees"
        [(ngModel)]="selectedEntree"
        textField="name"
        valueField="id"
        [defaultItem]="defaultEntree"
        (ngModelChange)="fetchCount()"
      ></kendo-dropdownlist>
    </div>

    <div class="form-row">
      <kendo-label text="Change Type"></kendo-label>
      <div class="radio-group">
        <label>
          <input type="radio" kendoRadioButton name="changeType" value="percent" [(ngModel)]="changeType" /> % Percentage
        </label>
        <label>
          <input type="radio" kendoRadioButton name="changeType" value="dollar" [(ngModel)]="changeType" /> $ Dollar Amount
        </label>
        <label>
          <input type="radio" kendoRadioButton name="changeType" value="overall" [(ngModel)]="changeType" /> % Overall
        </label>
      </div>
    </div>

    <div class="form-row" *ngIf="changeType === 'percent'">
      <kendo-label text="Percentage Change"></kendo-label>
      <kendo-numerictextbox
        [(ngModel)]="percentageChange"
        format="p2"
        [step]="0.01"
        [decimals]="4"
        [min]="-1"
        disableMouseWheel
      ></kendo-numerictextbox>
    </div>

    <div class="form-row" *ngIf="changeType === 'dollar'">
      <kendo-label text="Dollar Amount"></kendo-label>
      <kendo-numerictextbox
        [(ngModel)]="dollarChange"
        format="c2"
        [step]="0.01"
        [decimals]="2"
        disableMouseWheel
      ></kendo-numerictextbox>
    </div>

    <div class="form-row" *ngIf="changeType === 'overall'">
      <kendo-label text="Overall Percentage"></kendo-label>
      <kendo-numerictextbox
        [(ngModel)]="overallPercentage"
        format="p0"
        [step]="0.01"
        [decimals]="2"
        [min]="0"
        disableMouseWheel
      ></kendo-numerictextbox>
    </div>

    <div class="form-row">
      <kendo-label text="Rounding"></kendo-label>
      <div class="radio-group">
        <label>
          <input type="radio" kendoRadioButton name="roundDir" value="Up" [(ngModel)]="roundDirection" /> Up
        </label>
        <label>
          <input type="radio" kendoRadioButton name="roundDir" value="Down" [(ngModel)]="roundDirection" /> Down
        </label>
      </div>
    </div>

    <div class="form-row">
      <kendo-label text="To nearest"></kendo-label>
      <div class="radio-group">
        <label>
          <input type="radio" kendoRadioButton name="roundNearest" value="0" [(ngModel)]="roundToNearest" /> $0.00
        </label>
        <label>
          <input type="radio" kendoRadioButton name="roundNearest" value="5" [(ngModel)]="roundToNearest" /> $0.05
        </label>
        <label>
          <input type="radio" kendoRadioButton name="roundNearest" value="9" [(ngModel)]="roundToNearest" /> $0.09
        </label>
      </div>
    </div>


<div class="delivery-card-actions">
      <button kendoButton (click)="close.emit()">Cancel</button>
      <button
        kendoButton
        themeColor="primary"
        [disabled]="changeValue == null || affectedCount === 0"
        kendoTooltip
        [title]="affectedCount === 0 ? 'No items match the selected filters.' : ''"
        (click)="confirmApply()"
      >
        Apply
      </button>
    </div>
  </div>

</div>

<kendo-dialog
  *ngIf="showConfirm"
  title="Confirm Changes"
  (close)="showConfirm = false"
  [width]="400"
>
  <p *ngIf="changeType !== 'overall'">
    This will update the delivery price for <strong>{{ affectedCount }}</strong> items.
    Changes will be saved automatically. You'll still need to
    <strong>Schedule a Sync</strong> to push them to the POS.
  </p>
  <p *ngIf="changeType === 'overall'">
    This will set the delivery price for <strong>{{ affectedCount }}</strong> items
    to <strong>{{ overallPercentage | percent:'1.0-0' }}</strong> above the in-store price.
    Changes will be saved automatically. You'll still need to
    <strong>Schedule a Sync</strong> to push them to the POS.
  </p>
  <kendo-dialog-actions>
    <button kendoButton (click)="showConfirm = false">Cancel</button>
    <button kendoButton themeColor="primary" (click)="apply()">Confirm</button>
  </kendo-dialog-actions>
</kendo-dialog>

